import { useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button, TextDivider, Input, Card } from '../components/primitives/';
import { useAuth } from '../contexts/AuthContext'; 
import AuthButtons from '../components/AuthButtons';
import Logo from '../assets/pplogo.png';
import { useTranslation } from '../hooks/useTranslation';
import useTimedError from '../hooks/useTimedError';
import { catchErrorAuth } from '../ErrorUtility';

export default function Login() {
    const t = useTranslation();
    const location = useLocation();
    
    const emailRef = useRef();
    const passwordRef = useRef();
    const [email, setEmail] = useState(location.state?.email || "")
    const { login } = useAuth();
    const [error, setError] = useTimedError();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const [result, errorCode, errorMessage] = await catchErrorAuth(login, emailRef.current.value, passwordRef.current.value);
        if (errorCode) {
            setError(errorMessage);
            setLoading(false);
        } else {
            navigate("/");
        }
    }

  return (
    <div className="auth-page">
        <div className="auth-outer-container">
            <div className="logo-group">
                <a href="https://pageparrot.com" className="logo-group-inner">
                    <img className="logo-signin" src={Logo} alt="Page Parrot Logo"/>
                    <h2 className="logo-heading w-900 text-center">{t('Page Parrot')}</h2>
                </a>
            </div>
            <Card ctype="auth-container centered">
                <AuthButtons setLoading={setLoading} setError={setError} />
                <div styles={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <TextDivider>{t('Or')}</TextDivider>
                </div>
                <form onSubmit={handleSubmit}>
                    <Input ref={emailRef} value={email} labelText={t('Email')} id="email" required={true} onChange={handleEmailChange} />
                    <Input ref={passwordRef} labelText={t('Password')} id="password" type="password" required={true} />
                    <Button disabled={loading} buttonType="submit" loading={loading} error={error}>
                        {error ? error : t('Log In')}
                    </Button>
                </form>
                <br/>
                <p className="w-700 text-center" style={{ margin: "0" }}>{t('New to Page Parrot?')}</p>
                <div className="w-700 text-center signup-link link-text">
                    <Link to="/signup" state={{ email: emailRef.current?.value || email }} >
                        {t('Create Your Account')}
                    </Link>
                </div>
                <br/>
                <div className="w-500 fs-12 text-center">
                    <Link 
                        to="/forgot-password" 
                        state={{ email: emailRef.current?.value || email }}
                        style={{ textDecoration: "none" }}
                    >
                        {t('Forgot Password?')}
                    </Link>
                </div>
            </Card>
        </div>
    </div>
  )
}